import React from "react";
import { CancelSvg } from "../../../../svgFile";

const AuthModal = ({ id = "authModal", children, onClose, leftImage = "/image/login-left.png" }) => {
  return (
    <div className="modal fade login-modal" id={id} tabIndex="-1" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-body">
            <div className="row align-items-center">
              <div className="col-md-6 order-md-0 order-1">
                <div className="login-left mt-3 mt-md-0">
                  <img src={leftImage} className="img-fluid w-100" alt="" />
                </div>
              </div>
              <div className="col-md-6">
                <div className="d-flex justify-content-end">
                  <button type="button" className="login-close" data-bs-dismiss="modal" aria-label="Close" onClick={onClose}>
                    <CancelSvg />
                  </button>
                </div>
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;